import {
	Component
} from '@angular/core'

@Component({
	selector: 'refer-error',
	templateUrl: '../views/refer-error.component.html'
})

export class ReferErrorComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/refer-error.component.ts